var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGoogle)?_c('twoFa',{ref:"dialog",on:{"enter":_vm.enter}}):_vm._e(),(_vm.isCode)?_c('codeCheck',{ref:"codeDialog",on:{"enter":_vm.enter}}):_vm._e(),(_vm.isTip)?_c('safeModalTip'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }